import React, {useState} from 'react';
import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import { observer } from "mobx-react";
import { BettingZoneDrawerMenuHeader } from "./betting-zone.drawer-menu.header";
import {useBettingZoneNavigation} from "../useBettingZoneNavigation";
import {BettingZoneDrawerMenuContent} from "./betting-zone.drawer-menu.content";

export const BettingZoneDrawerMenu = observer(({ controller, isMenuVisible, setIsMenuVisible}) => {
  const {selectedItem, activeItems, navigate} = useBettingZoneNavigation(controller,null, true);
  const [expandedItemId, setExpandedItemId] = useState(null);

  const headerProps = {
    controller,
    setIsMenuVisible,
    isMenuVisible,
    selectedItem,
    expandedItemId,
    setExpandedItemId,
    navigate
  }

  const contentProps = {
    controller,
    activeItems,
    navigate,
    setIsMenuVisible,
    expandedItemId,
    setExpandedItemId,
    selectedItem
  }

  return (
    <div className={classNames(styles.container, {[styles.container_visible]: isMenuVisible})} data-theme={controller.state.appState.theme}>
      <BettingZoneDrawerMenuHeader {...headerProps}/>
      <BettingZoneDrawerMenuContent {...contentProps}/>
    </div>
  );
});